import(/* webpackMode: "eager" */ "/app/src/app/(website)/hotel/[city]/[slug]/error.tsx");
